/* Emițătorul de intenție: formulare, chat, 3D/AR, secțiuni PDP, contact, galerie, documente.
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-intentie-tracking.js` în tema DEV
 * și se include din `theme.liquid`, după `am-interactiuni-tracking.js`.
 *
 * DE CE (15.10.2026): auditul RO din 13.10 (§5.4) a găsit ZERO evenimente pentru formularul de
 * contact, programarea în showroom, chat, 3D/AR, documente și galerie, iar `scroll`-ul nativ GA4
 * se declanșează pe 86% din pagini la ~1,5 s (inutilizabil). Drumul e cel care merge deja:
 * `Shopify.analytics.publish('audio_monkey:…')` → pixelul propriu (`ascultator-pixel.js`) →
 * proxy-ul MP din Worker (schemă per eveniment, `worker/src/ga4-mp-proxy.ts`) → GA4/BigQuery.
 * Fără consimțământ pixelul nu trimite nimic; emițătorul doar publică.
 *
 * NICIO DATĂ PERSONALĂ: din formulare se citește DOAR tipul (clasa formularului, `form_type`,
 * eticheta statică `contact[tags]` pusă de temă) și, la panoul openbox, DOAR dacă telefonul e
 * completat — niciodată valoarea. Contactul trimite canalul (hartă/telefon/email) și suprafața,
 * nu numărul sau adresa. Pe pagini de conținut se trimite calea `/pages/<handle>`.
 *
 * LIMITE DECLARATE:
 *  - Chatul Shopify Inbox rulează într-un iframe: se vede DESCHIDEREA, nu mesajele.
 *  - `trimis` pleacă la submit, chiar înainte de navigarea POST; poate să nu ajungă. `confirmat`
 *    vine de pe pagina de succes întoarsă de Shopify (`contact_posted` / `customer_posted`) și e
 *    cifra de citit. Formularul openbox deschide WhatsApp: are `deschis` și `trimis`, nu confirmare.
 *  - Galeria numără și schimbările de imagine făcute de alegerea unei variante.
 *  - Secțiunile PDP se evaluează DOAR la evenimente de derulare (niciodată la încărcare — exact
 *    defectul `scroll`-ului nativ, care evalua pragul înainte ca pagina să-și capete înălțimea).
 */
(function () {
  'use strict';

  if (window.__amIntentieTracking) return;   // inclus de două ori = evenimente dublate
  window.__amIntentieTracking = true;

  function publica(nume, d) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('audio_monkey:' + nume, d);
      }
    } catch (err) { /* măsurarea nu are voie să strice pagina */ }
  }

  /* O singură dată per încărcare de pagină, pe cheie. */
  var trimise = {};
  function oData(cheie, nume, d) {
    if (trimise[cheie]) return;
    trimise[cheie] = 1;
    publica(nume, d);
  }

  var PDP = /\/products\//.test(location.pathname);
  var RE_PAGINA = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(\/pages\/[a-z0-9-]{1,80})$/;
  /* LISTĂ ÎNCHISĂ (review Codex 15.10): paginile de conținut cu hartă/telefon. Un handle liber ar
   * lăsa un apelant direct al proxy-ului să trimită `/pages/0722123456` în GA4. O pagină nouă se
   * adaugă aici, în pixel ȘI în proxy; până atunci clicurile de pe ea intră la `alt`. */
  var PAGINI = { '/pages/contact': 1, '/pages/programare': 1, '/pages/showroom-bang-olufsen-aviatiei': 1,
    '/pages/sonos-official-store-romania': 1 };

  function inchis(el, sel) {
    try { return !!(el && el.closest && el.closest(sel)); } catch (err) { return false; }
  }

  // ─── Formulare ──────────────────────────────────────────────────────────────
  var FORMULARE = { contact: 1, programare: 1, newsletter: 1, openbox_apel: 1 };
  var CHEIE_TRIMIS = 'am_formular_trimis';
  var CHEIE_CONFIRMAT = 'am_formular_confirmat';
  var VALABIL_MS = 10 * 60 * 1000;

  function tipFormular(f) {
    if (f.matches('[data-am-ask-form]')) return 'openbox_apel';
    var ft = f.querySelector('input[name="form_type"]');
    ft = ft ? ft.value : '';
    if (ft === 'customer') return 'newsletter';
    if (ft !== 'contact') return null;
    if (f.classList.contains('am-book__form')) return 'programare';
    // Eticheta e pusă de temă (câmp ascuns), nu scrisă de client.
    var tags = f.querySelector('input[name="contact[tags]"]');
    if (tags && /newsletter/i.test(tags.value || '')) return 'newsletter';
    return 'contact';
  }

  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.matches) return;
      var tip = tipFormular(f);
      if (!tip) return;
      if (tip === 'openbox_apel') {
        // Tema refuză trimiterea fără telefon; doar verificăm că e completat, fără să-l citim.
        var tel = f.querySelector('#am-openbox-ask-phone');
        if (!tel || !String(tel.value || '').trim()) return;
        publica('formular', { formular: tip, etapa: 'trimis' });
        return;
      }
      publica('formular', { formular: tip, etapa: 'trimis' });
      try {
        sessionStorage.setItem(CHEIE_TRIMIS, JSON.stringify({ f: tip, t: Date.now() }));
        // O trimitere NOUĂ poate întoarce la același URL de succes: marca veche nu are voie s-o blocheze.
        sessionStorage.removeItem(CHEIE_CONFIRMAT);
      } catch (err) {}
    } catch (err) { /* idem */ }
  }, true);

  /* Pagina de succes: Shopify redirecționează cu `?contact_posted=true` (contact) sau
   * `?customer_posted=true` (newsletter). Tipul vine din marca lăsată la submit; o reîncărcare a
   * aceleiași pagini de succes nu se mai numără. */
  (function confirmare() {
    try {
      var q = location.search || '';
      var contact = /[?&]contact_posted=true(?:&|$)/.test(q);
      var client = /[?&]customer_posted=true(?:&|$)/.test(q);
      if (!contact && !client) return;
      if (sessionStorage.getItem(CHEIE_CONFIRMAT) === location.href) return;
      var tip = null;
      var o = JSON.parse(sessionStorage.getItem(CHEIE_TRIMIS) || 'null');
      if (o && FORMULARE[o.f] && o.f !== 'openbox_apel' && Date.now() - o.t < VALABIL_MS) tip = o.f;
      if (!tip && client) tip = 'newsletter';
      sessionStorage.removeItem(CHEIE_TRIMIS);
      sessionStorage.setItem(CHEIE_CONFIRMAT, location.href);
      if (tip) publica('formular', { formular: tip, etapa: 'confirmat' });
    } catch (err) { /* storage indisponibil: nu știm ce formular a fost → nu inventăm */ }
  })();

  // ─── Clicuri: panou openbox, chat, AR, contact, documente ─────────────────────
  var RE_HARTA = /^https?:\/\/(?:(?:www\.)?google\.[a-z.]+\/maps|maps\.google\.[a-z.]+|maps\.app\.goo\.gl|goo\.gl\/maps|(?:www\.)?waze\.com|maps\.apple\.com)/i;
  var TIPURI_DOC = { manual: 1, fisa: 1 };

  function suprafataContact(a) {
    if (inchis(a, 'footer, .shopify-section-group-footer-group')) return { suprafata: 'subsol' };
    if (inchis(a, 'header, .shopify-section-group-header-group')) return { suprafata: 'antet' };
    if (PDP) return { suprafata: 'pdp' };
    var m = RE_PAGINA.exec(location.pathname);
    return m && PAGINI[m[1]] ? { suprafata: 'pagina', pagina: m[1] } : { suprafata: 'alt' };
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-am-openbox-ask]')) {
        oData('openbox_deschis', 'formular', { formular: 'openbox_apel', etapa: 'deschis' });
        return;
      }

      var chat = t.closest('#am-chat-launcher .am-chat-close, #am-chat-launcher .am-chat-monkey, #am-chat-launcher .am-chat-bubble');
      if (chat) {
        if (chat.classList.contains('am-chat-close')) oData('chat_ascuns', 'chat', { actiune: 'ascuns', sursa: 'lansator' });
        else oData('chat_deschis', 'chat', { actiune: 'deschis', sursa: 'lansator' });
        return;
      }
      /* Activatorul nativ (după ce lansatorul propriu a fost ascuns) stă în shadow DOM-ul
       * `<shopify-chat>`. Doar clicuri reale: lansatorul propriu îi trimite un clic sintetic. */
      if (e.isTrusted && e.composedPath) {
        var cale = e.composedPath();
        for (var i = 0; i < cale.length; i++) {
          if (cale[i] && cale[i].tagName === 'SHOPIFY-CHAT') {
            oData('chat_deschis', 'chat', { actiune: 'deschis', sursa: 'nativ' });
            return;
          }
        }
      }

      if (t.closest('[data-shopify-xr]')) { oData('3d_ar', '3d', { actiune: 'ar' }); return; }

      var doc = t.closest('a.am-product-document');
      if (doc) {
        var tipDoc = doc.getAttribute('data-am-doc');
        publica('document', { document_tip: TIPURI_DOC[tipDoc] ? tipDoc : 'alt' });
        return;
      }

      if (!e.isTrusted) return;
      var a = t.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var canal = /^tel:/i.test(href) ? 'telefon' : /^mailto:/i.test(href) ? 'email' : RE_HARTA.test(href) ? 'harta' : null;
      if (!canal) return;
      var s = suprafataContact(a);
      var d = { canal: canal, suprafata: s.suprafata };
      if (s.pagina) d.pagina = s.pagina;
      publica('contact_click', d);
    } catch (err) { /* idem */ }
  }, true);

  // ─── 3D: rotire reală ─────────────────────────────────────────────────────────
  /* Ascultător în faza de CAPTURĂ: `camera-change` nu urcă prin DOM, dar captura de pe document îl
   * vede oricum. `source: 'user-interaction'` exclude rotirea automată și poziționarea inițială. */
  document.addEventListener('camera-change', function (e) {
    try {
      if (e.target && e.target.tagName === 'MODEL-VIEWER' && e.detail && e.detail.source === 'user-interaction') {
        oData('3d_rotit', '3d', { actiune: 'rotit' });
      }
    } catch (err) { /* idem */ }
  }, true);

  // ─── 3D: model văzut (≥ 50% în ecran, ≥ 1 s) ──────────────────────────────────
  function urmaresteVizibil(el, cheie, fn) {
    if (!el || typeof IntersectionObserver === 'undefined') return;
    var timer = null;
    var io = new IntersectionObserver(function (intrari) {
      for (var i = 0; i < intrari.length; i++) {
        if (intrari[i].isIntersecting && intrari[i].intersectionRatio >= 0.5) {
          if (!timer) timer = setTimeout(function () { io.disconnect(); oData(cheie, fn.nume, fn.d); }, 1000);
        } else if (timer) { clearTimeout(timer); timer = null; }
      }
    }, { threshold: [0, 0.5] });
    io.observe(el);
  }
  function porneste3d() {
    var modele = document.querySelectorAll('model-viewer');
    for (var i = 0; i < modele.length; i++) urmaresteVizibil(modele[i], '3d_vazut', { nume: '3d', d: { actiune: 'vazut' } });
  }

  // ─── Galeria de pe PDP ────────────────────────────────────────────────────────
  /* Swiper marchează imaginea curentă cu `swiper-slide-active`. Se numără fiecare poziție NOUĂ,
   * mai mare decât tot ce s-a văzut; reperul inițial e imaginea activă la pornire (o variantă
   * aleasă din URL poate deschide galeria direct pe poziția 5 — aia nu e o alegere).
   * La schimbarea variantei tema ÎNLOCUIEȘTE `.l4pr-container` (custom-async.js, `innerHTML`), deci
   * observatorul stă pe SECȚIUNE, iar wrapper-ul se re-caută la fiecare mutație; o galerie nouă
   * primește un reper nou și nu emite nimic până la prima navigare (review Codex 15.10). */
  var SEL_GALERIE = '[id*="__main-product"] .l4pr .swiper-outer > .swiper-wrapper';
  function pornesteGaleria() {
    var sectiune = document.querySelector('[id*="__main-product"]');
    if (!sectiune || typeof MutationObserver === 'undefined') return;
    var wrap = null, max = 1;
    function activ(w) {
      var s = w.children;
      for (var i = 0; i < s.length; i++) if (s[i].classList.contains('swiper-slide-active')) return i;
      return -1;
    }
    function verifica() {
      var w = document.querySelector(SEL_GALERIE);
      if (!w) return;
      var i = activ(w);
      if (w !== wrap) { wrap = w; max = Math.max(1, i + 1); return; }
      var poz = i + 1;
      if (i < 0 || poz <= max || poz > 40) return;
      max = poz;
      var slide = w.children[i];
      var media = slide.querySelector('model-viewer') ? '3d' : slide.querySelector('video, iframe') ? 'video' : 'imagine';
      publica('galerie', { pozitie: poz, media: media });
    }
    verifica();
    new MutationObserver(verifica).observe(sectiune, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  // ─── Secțiunile PDP (în locul `scroll`-ului nativ) ────────────────────────────
  function pornesteSectiunile() {
    var programat = false;
    function evalueaza() {
      programat = false;
      var vh = window.innerHeight || 0;
      if (!vh) return;
      var rich = document.querySelector('.am-rich-description');
      if (rich) {
        var r = rich.getBoundingClientRect();
        if (r.height > 0) {
          if (r.top < vh * 0.75) oData('sec_descriere', 'pdp_sectiune', { sectiune: 'descriere' });
          if ((vh - r.top) / r.height >= 0.5) oData('sec_descriere_50', 'pdp_sectiune', { sectiune: 'descriere_50' });
          if (r.bottom <= vh) oData('sec_descriere_final', 'pdp_sectiune', { sectiune: 'descriere_final' });
        }
      }
      var rec = document.getElementById('judgeme_product_reviews');
      if (rec) {
        var rr = rec.getBoundingClientRect();
        if (rr.height > 0 && rr.top < vh * 0.75) oData('sec_recenzii', 'pdp_sectiune', { sectiune: 'recenzii' });
      }
      var sub = document.querySelector('.shopify-section-group-footer-group');
      if (sub && sub.getBoundingClientRect().top < vh) oData('sec_subsol', 'pdp_sectiune', { sectiune: 'subsol' });
      // Subsolul e ultimul prag: după el nu mai e nimic de măsurat (review Codex 15.10).
      if (trimise.sec_subsol && window.removeEventListener) window.removeEventListener('scroll', laDerulare);
    }
    function laDerulare() {
      if (programat) return;
      programat = true;
      (window.requestAnimationFrame || setTimeout)(evalueaza);
    }
    window.addEventListener('scroll', laDerulare, { passive: true });
  }

  function pornestePdp() {
    try { porneste3d(); } catch (err) {}
    if (!PDP) return;
    try { pornesteGaleria(); } catch (err) {}
    try { pornesteSectiunile(); } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pornestePdp);
  else pornestePdp();
})();
